import { NumberInput } from '@/components/NumberInput';
import { Label } from '@/components/ui/label';
import { Slider } from '@/components/ui/slider';
import { useSimulatorState } from '@/store/useSimulatorState';

export function ProjectionPanel() {
  const { projection, updateProjection } = useSimulatorState();
  const { horizonMonths } = projection;

  return (
    <div className="flex flex-col gap-4 py-2">
      <div className="flex items-center justify-between">
        <Label htmlFor="horizonMonths">Horizon de projection</Label>
        <span className="text-sm font-semibold">{horizonMonths} mois</span>
      </div>
      <Slider
        id="horizonMonths"
        value={[horizonMonths]}
        onValueChange={([v]) => {
          if (v !== undefined) updateProjection({ horizonMonths: v });
        }}
        min={3}
        max={60}
        step={1}
        aria-label="Horizon de projection en mois"
      />
      <div className="flex items-center gap-2">
        <Label htmlFor="horizonMonthsInput" className="shrink-0 text-xs text-muted-foreground">
          Saisie directe (3 – 60) :
        </Label>
        <NumberInput
          id="horizonMonthsInput"
          value={horizonMonths}
          onChange={(v) =>
            updateProjection({ horizonMonths: Math.min(60, Math.max(3, Math.round(v))) })
          }
          min={3}
          max={60}
          decimals={0}
          className="w-20"
        />
      </div>
    </div>
  );
}
